export default ({ COLORS }) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  desc: {
    display: 'flex',
    flexDirection: 'column'
  },
  avatar: {
    fontSize: '48px !important',
    margin: '0 20px 0 0'
  },
  name: {
    fontSize: '22px',
    lineHeight: '22px',
    color: COLORS.TEXT.MID_GREY.NORMAL
  },
  displayName: {
    fontSize: '18px',
    lineHeight: '18px',
    color: COLORS.TEXT.LIGHT_GREY.NORMAL
  }
})
